import React, { useRef, useState } from "react";
import { RotateCcw } from "lucide-react";

const AddTransactionSavings = ({
  id,
  closeAddTransactionSavingsOpen,
  isAddTransactionSavingsOpen,
  transMode,
  setTransMode,
  amount,
  setAmount,
  date,
  setDate,
  accNumber,
  setAccNumber,
  refNumber,
  setRefNumber,
  docFile,
  setDocFile,
  handleManualTransaction,
  savingsChecked,
  setSavingsChecked,
}) => {
  const fileInputFront = useRef(null);

  const [formattedAmount, setFormattedAmount] = useState("");

  const handleAmountChange = (e) => {
    let value = e.target.value;

    // remove commas + anything not a digit
    const rawValue = value?.replace(/[^0-9]/g, "");

    // format with commas
    const formattedValue = rawValue
      ? new Intl.NumberFormat()?.format(rawValue)
      : "";

    setAmount(rawValue); // clean value for logic/API
    setFormattedAmount(formattedValue); // UI display
  };

  const openFrontFilePicker = () => {
    fileInputFront.current.click();
  };

  const handlePhotoFileChange = (e) => {
    const file = e.target.files[0];
    setDocFile(file);
  };

  const handleCloseAddTransactionSavingsOpen = () => {
    // setTransMode("");
    setAmount("");
    setRefNumber("");
    setAccNumber("");
    setDocFile(null);
    setDate("");
    setSavingsChecked(false);

    closeAddTransactionSavingsOpen();
  };

  const truncateFileName = (fileName) => {
    const maxLength = 12;
    const extensionIndex = fileName.lastIndexOf(".");
    const nameWithoutExtension = fileName.substring(0, extensionIndex);
    const truncatedName =
      nameWithoutExtension.length > maxLength
        ? `${nameWithoutExtension.substring(0, maxLength)}...`
        : nameWithoutExtension;
    return `${truncatedName}.${fileName.substring(extensionIndex + 1)}`;
  };

  const isFormComplete =
    transMode &&
    amount &&
    accNumber &&
    refNumber &&
    date &&
    docFile &&
    savingsChecked;

  const getTodayDate = () => {
    const today = new Date();
    return today?.toISOString()?.split("T")[0];
  };

  const handleReplaceFile = () => {
    fileInputFront.current?.click();
  };

  return (
    <>
      <div
        id={id}
        className={`${
          isAddTransactionSavingsOpen ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="relative flex fixed min-h-[80%] w-[60%]">
          <div className="relative flex bg-white shadow w-full mx-auto">
            <div className="flex flex-col justify-between w-full px-5">
              <div>
                <div className="flex items-center justify-end">
                  <button
                    onClick={handleCloseAddTransactionSavingsOpen}
                    type="button"
                    className="bg-transparent  rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                    data-modal-toggle={id}
                  >
                    <svg
                      width="61"
                      height="43"
                      viewBox="0 0 61 43"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_13891_3896)">
                        <path
                          d="M32.84 28L30.7 24.9L28.9 28H25.2L28.88 22.3L25.1 16.84H28.94L31.08 19.92L32.88 16.84H36.58L32.84 22.46L36.68 28H32.84Z"
                          fill="black"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_13891_3896">
                          <rect width="61" height="43" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span className="sr-only">Close modal</span>
                  </button>
                </div>
                <div className="mt-3 mx-auto items-center">
                  <p className="text-[#000] text-xl font-bold">
                    Add a Transaction - Savings
                  </p>
                  <div className="text-[#000] mt-3 text-sm font-normal">
                    <p>
                      Manually add a transaction for Savings. Select the payment
                      type, choose the transaction mode, add amount,
                      <br />
                      select date, upload transaction receipt and update records
                      seamlessly
                    </p>
                  </div>
                </div>

                <div className="flex justify-between w-full mt-8">
                  <div className="flex w-[48%] flex-col justify-center">
                    <label
                      htmlFor="nameInput"
                      className="mb-1 text-md font-medium text-[#000]"
                    >
                      Transaction mode
                    </label>
                    <select
                      name="mode"
                      id="mode"
                      value={transMode}
                      onChange={(e) => setTransMode(e.target.value)}
                      className="w-full h-10 px-4 rounded-[4px] border-[1px] border-[#000]"
                    >
                      <option value="MPESA">M-PESA</option>
                      <option value="BANK">BANK</option>
                    </select>
                  </div>
                  <div className="flex w-[48%] flex-col justify-center">
                    <label
                      htmlFor="nameInput"
                      className="mb-1 text-md font-medium text-[#000]"
                    >
                      Account number/ Phone Number
                    </label>
                    <input
                      type="text"
                      id="mobileNumberInput"
                      name="mobileno"
                      placeholder="Enter Account number/ Phone Number"
                      value={accNumber}
                      onChange={(e) => setAccNumber(e.target.value)}
                      className="w-[95%] h-10 px-4 rounded-[4px] border border-[1px] border-[#000]"
                    />
                  </div>
                </div>
                <div className="flex w-full justify-between mt-8">
                  <div className="flex w-[48%] flex-col justify-center">
                    <label
                      htmlFor="nameInput"
                      className="mb-1 text-md font-medium text-[#000]"
                    >
                      Amount
                    </label>
                    <div className="flex items-center h-10 rounded-[4px] border border-[1px] border-[#000000]">
                      <div className="flex items-center justify-center text-[#000] w-[20%] h-10 font-normal border-r border-t border-b  border-[#000000]">
                        KES
                      </div>
                      <input
                        type="text"
                        id="amountInput"
                        name="amount"
                        placeholder="Enter amount"
                        value={formattedAmount}
                        onChange={handleAmountChange}
                        className="w-[80%] h-9 px-4"
                      />
                    </div>
                  </div>
                  <div className="flex w-[48%] flex-col justify-center">
                    <label
                      htmlFor="nameInput"
                      className="mb-1 text-md font-medium text-[#000]"
                    >
                      Reference No.
                    </label>
                    <input
                      type="text"
                      id="refNumberInput"
                      name="refNumber"
                      placeholder="Enter the reference Number"
                      value={refNumber}
                      onChange={(e) => setRefNumber(e.target.value)}
                      className="w-[95%] h-10 px-4 rounded-[4px] border border-[1px] border-[#000]"
                    />
                  </div>
                </div>
                <div className="flex w-full items-start justify-between mt-10">
                  <div className="flex w-[48%] flex-col justify-center">
                    <label
                      htmlFor="dobInput"
                      className="mb-1 text-md font-medium text-[#000]"
                    >
                      Date
                    </label>
                    <input
                      type="date"
                      id="dateInput"
                      name="date"
                      placeholder="Enter the date"
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                      max={getTodayDate()}
                      className="w-full h-10 px-4 rounded-[4px] border border-[1px] border-[#000]"
                    />
                  </div>
                  <div className="flex w-[48%] flex-col justify-center">
                    <label
                      htmlFor="genderSelect"
                      className="mb-1 text-md font-medium text-[#000]"
                    >
                      Upload Transaction Receipt
                    </label>
                    <div
                      onClick={openFrontFilePicker}
                      className="w-full h-[95px] rounded-[4px] bg-[#EAEAEA] flex items-center justify-center flex-col cursor-pointer"
                    >
                      <svg
                        width="45"
                        height="45"
                        viewBox="0 0 45 45"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M21.5625 29.2069V12.9881L17.1938 17.3569L15.8663 16.0106L22.5 9.375L29.1356 16.0106L27.8081 17.3588L23.4375 12.9881V29.2069H21.5625ZM12.405 35.625C11.5413 35.625 10.8206 35.3363 10.2431 34.7588C9.66562 34.1812 9.37625 33.46 9.375 32.595V28.0519H11.25V32.595C11.25 32.8838 11.37 33.1488 11.61 33.39C11.85 33.6313 12.1144 33.7512 12.4031 33.75H32.5969C32.8844 33.75 33.1488 33.63 33.39 33.39C33.6313 33.15 33.7512 32.885 33.75 32.595V28.0519H35.625V32.595C35.625 33.4588 35.3363 34.1794 34.7588 34.7569C34.1812 35.3344 33.46 35.6238 32.595 35.625H12.405Z"
                          fill="black"
                        />
                      </svg>
                      <input
                        type="file"
                        ref={fileInputFront}
                        onChange={handlePhotoFileChange}
                        style={{ display: "none" }}
                      />

                      <p className="text-#074073B8 text-16 text-center">
                        {!docFile ? (
                          <>
                            Drag and Drop or{" "}
                            <span style={{ color: "#0187E8" }}>
                              Choose file
                            </span>{" "}
                            here
                          </>
                        ) : (
                          truncateFileName(docFile.name)
                        )}
                      </p>

                      {docFile && (
                        <div className="flex flex-col items-center mt-1">
                          <p className="text-#074073B8 w-90% truncate text-16 text-center">
                            {docFile.type} ({(docFile.size / 1024).toFixed(2)}{" "}
                            KB)
                          </p>

                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleReplaceFile();
                            }}
                            className="mt-2 flex items-center gap-2 px-3 py-1.5 rounded-[5px] bg-[#E6F0FF] hover:bg-[#D9E9FF] text-[#074073] transition-all duration-200"
                          >
                            <RotateCcw size={15} />
                            <span className="text-sm font-medium">
                              Replace File
                            </span>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="flex items-start gap-4 mt-5">
                  <input
                    type="checkbox"
                    checked={savingsChecked}
                    onChange={() => setSavingsChecked(!savingsChecked)}
                    className="saving-checkbox"
                  />
                  <label>
                    I confirm that the payment details entered are accurate and
                    have been verified. This transaction will be recorded
                    manually in the system.
                  </label>
                </div>
              </div>
              <div className="flex items-end justify-end mt-8 mb-6">
                <button
                  onClick={handleManualTransaction}
                  type="submit"
                  disabled={!isFormComplete}
                  className={`px-8 py-2 rounded-[6px] text-white font-medium cursor-pointer ${
                    isFormComplete ? "bg-[#074073]" : "bg-[#D9D9D9]"
                  }`}
                >
                  Add Payment
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddTransactionSavings;
